import React from "react";

const SearchFilter = ({ search, setSearch }) => {
  return (
    <div className="relative w-full max-w-full mb-1">
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search Design / Shade..."
        className="w-full h-25 pl-10 pr-4 py-2 border-gray-300 rounded-sm shadow-sm focus:outline-none"
        style={{ border: "1px solid #ece9e9" }}
      />

      <div
        className="absolute inset-y-0 left-0 pl-3 d-flex align-items-center"
        style={{ color: "rgb(146 146 146)" }}
      >
        <i className="bi bi-search"></i>
      </div>
    </div>
  );
};

export default SearchFilter;